// src/regl/ReglElements.ts
import { gl } from "@antv/l7-core";
import { dataTypeMap, usageMap } from "./constants";
var ReglElements = class {
  constructor(reGl, options) {
    const { data, usage, type, count } = options;
    this.elements = reGl.elements({
      data,
      usage: usageMap[usage || gl.STATIC_DRAW],
      type: dataTypeMap[type || gl.UNSIGNED_BYTE],
      count
    });
  }
  get() {
    return this.elements;
  }
  subData({
    data
  }) {
    this.elements.subdata(data);
  }
  destroy() {
  }
};
export {
  ReglElements as default
};
